import cx from 'classnames';
import type { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Counter, Icon } from '@zen/DesignSystem';

interface Props {
  count?: number;
  isActive: boolean;
  isHighlighted?: boolean;
  label: string;
  openInNewTab?: boolean;
  url: string;
}

const NavChildLink: FC<Props> = ({ count = 0, isActive, isHighlighted, label, openInNewTab, url }) => {
  const classNames: string = cx(
    {
      'text-azure-base': isActive,
      'text-navy-base': !isActive && !isHighlighted,
      'hover:text-azure-base': !isActive && !isHighlighted
    },
    'text-base xl:text-sm leading-normal py-0.5 pl-10 flex items-center transition-all duration-200 ease-linear'
  );

  const labelClassNames: string = cx(
    {
      'bg-sunset-base text-transparent bg-clip-text': isHighlighted && !isActive,
      'text-azure-base': isActive
    },
    'flex items-center space-x-1 pl-2 hover:text-azure-base group'
  );

  const iconClassNames: string = cx({ 'text-transparent': isHighlighted && !isActive }, 'group-hover:text-azure-base');

  const activeIndicatorClassNames: string = cx(
    { 'bg-azure-base': isActive, 'bg-transparent': !isActive },
    'w-1 h-6 rounded-l transition-all duration-200 ease-linear'
  );

  const navChildLinkCounter: ReactNode = count ? <Counter className="mr-2" size="small" type="active" value={count} /> : null;

  return (
    <Link className={classNames} data-component="nav-item" target={openInNewTab ? '_blank' : undefined} to={url}>
      <span className={labelClassNames}>
        <span>{label}</span>
        {isHighlighted && <Icon className={iconClassNames} icon="zicon-sparkles-filled" />}
      </span>
      <span className="flex ml-auto">{navChildLinkCounter}</span>
      <span className={activeIndicatorClassNames} />
    </Link>
  );
};

export default NavChildLink;
